import AScene from '../../library/ExtendedObjects/AScene.js';
import Rivette from '../intro/Rivette.js';
import NavBar from './NavBar.js';
import DialoguePopup from './DialoguePopup.js';
import gameData from '../../gameData.js';
import PortalImport from './PortalImport.js';
import PortalExport from './PortalExport.js';
import Machine from './Machine.js';
import PortalDuo from './PortalDuo.js';
import InputMachine from './InputMachine.js';
import Keyboard from './Keyboard.js';
import Popup from './Popup.js';

export default class Game extends AScene
{
    static get KEY() { return 'Game'; }

    create()
    {
        gameData.score = 0;
        gameData.gameOver = false;
        gameData.gamePaused = false;

        this.addImage(this.mid.x, this.mid.y, "Bckg1Large");
        this.gradient = this.addImage(this.mid.x, 220, "TitleScreenGradient");
        this.gradient.alpha = 0;
        this.addTween(this.gradient, 1000, {alpha: 1}, Phaser.Math.Easing.None);

        this.initGame = true;

        this.createNavbar();
        this.createRivette();
    }

    createRivette()
    {
        this.rivette = this.addContainer(0, 0, new Rivette(this, -100, 775, "game"), this);
        
        //hack way of preventing the "blipping effect"
        this.rivette.character.spine.setDepth(-1);
        this.addDelay(50, ()=>{this.tweenInRivette();});
    }

    tweenInRivette()
    {
        this.rivette.character.spine.setDepth(2);

        this.addTween(this.rivette.character.spine, 1000, {x:160}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{
                this.rivette.playAnimation("idle", true);
                this.startLevel();
            });
    }

    createNavbar()
    {
        if(gameData.round === 1) {
            this.navBar = this.addContainer(0, 0, new NavBar(this, true), this);
        } else {
            this.navBar = this.addContainer(0, 0, new NavBar(this), this);
        }
    }

    createPortals()
    {
        if(gameData.round === 1){
            this.smallPortal = this.addContainer(790, 950, new PortalImport(this));
            this.largePortal = this.addContainer(455, -300, new PortalExport(this));

            this.largePortal.setDepth(1);
        }
        else if(gameData.round === 2){
            this.shuffleArray(gameData.sentences);

            this.smallPortal = this.addContainer(this.mid.x, -100, new Machine(this));
            this.largePortal = this.addContainer(this.mid.x + 100, 1050, new PortalDuo(this));
        
            this.largePortal.setDepth(1);
        }
        else if(gameData.round === 3){
            this.shuffleArray(gameData.combined);

            this.smallPortal = this.addContainer(this.mid.x + 25, -200, new InputMachine(this));
            this.largePortal = this.addContainer(this.mid.x, 1050, new Keyboard(this));
        
            this.largePortal.setDepth(4);
        }

        this.smallPortal.setDepth(1);
        this.navBar.setDepth(3);
    }

    showDialogue(step)
    {
        this.dialogue = this.addContainer(0, 0, new DialoguePopup(this, step));
    }

    startLevel()
    {
        gameData.score = 0;
        gameData.gameOver = false;

        this.createPortals();

        if(gameData.showTutorial){
            if(gameData.round === 1) {
                this.showDialogue(0);
            } 
            else if(gameData.round === 2) {
                if(this.initGame){
                    this.showDialogue(2);
                }
            } 
            else {
                if(this.initGame){
                    this.showDialogue(3);
                }
            }
        } else {
            this.tweenInPortals();
        }
    }

    skipStart()
    {
        this.dialogue = null;

        gameData.score = 0;
        gameData.gameOver = false;

        if(gameData.round === 3) {
            this.addTween(this.rivette.character.spine, 2000, {x:100, y:620}, Phaser.Math.Easing.Quadratic.Out);
        }

        this.tweenInPortals();
    }

    checkClick(obj)
    {
        if(obj.length){
          if(obj[0].name)
          {
            if(obj[0].name === "sound") return;

            if(obj[0].name === "del"){
                this.playSound("type_letter");
                this.smallPortal.word.text.setText(this.smallPortal.word.text.text.slice(0, -1));
            } 
            else if(obj[0].name === "check"){
                this.playSound("type_letter");
                this.checkWord();
            } 
            else if (this.smallPortal.word.maxCharacters === -1 || this.smallPortal.word.text.text.length < this.smallPortal.word.maxCharacters) {
                this.playSound("type_letter");
                this.smallPortal.word.text.setText(this.smallPortal.word.text.text + obj[0].name);
            }
            
            this.smallPortal.word.updateTextSize();
            this.smallPortal.word.updateCaret();
          }
        }
    }

    checkWord()
    {
        if(this.smallPortal.word.text.text !== ""){
            this.smallPortal.word.lostFocus();
            this.largePortal.disableKeys();

            if(this.smallPortal.word.text.text === gameData.combined[0].past){
                this.smallPortal.getArtifact();
                this.rivette.playAnimation("right");
            }
            else {
                this.navBar.turnOnAlarm();
                this.smallPortal.flicker();
                this.rivette.playAnimation("medium");
                this.rivette.dialogueWords();

                this.playSound("round_3_wrong_answer");

                this.navBar.updateLevel();
            }
        }
    }

    tweenInPortals()
    {
        this.largePortal.tweenInPortal();
        this.smallPortal.tweenInPortal();
    }

    tweenOutPortals()
    {
        this.largePortal.tweenOutPortal();
        this.smallPortal.tweenOutPortal();

        this.addDelay(1010, ()=>{this.startLevel();});
    }
    
    rotateSmallPortal()
    {
        this.addTween(this.smallPortal, 10000, {angle:-360, repeat:-1}, Phaser.Math.Easing.None);
    }

    pauseGame()
    {
        gameData.gamePaused = true;

        this.playSound("click");

        this.pause = this.addContainer(0, 0, new Popup(this));

        this.navBar.disableButtons();

        if(this.dialogue) this.dialogue.disableButton();

        if(gameData.round === 1){
            if(this.largePortal) this.largePortal.disableWords();
        }
        else if(gameData.round === 2){
            if(this.largePortal) this.largePortal.disableWords();
        }
        else if(gameData.round === 3){
            if(this.smallPortal) {
                this.smallPortal.word.lostFocus();
                this.smallPortal.disableBtn();
            }
            
            if(this.largePortal) this.largePortal.disableKeys();
        }
    }

    resumeGame()
    {
        gameData.gamePaused = false;

        this.pause.cleanUp();
        this.pause.destroy();

        this.navBar.enableButtons();

        if(this.dialogue) this.dialogue.enableButton();

        if(gameData.round === 1){
            if(this.largePortal) this.largePortal.enableWords();
        }
        else if(gameData.round === 2){
            if(this.largePortal) this.largePortal.enableWords();
        }
        else if(gameData.round === 3){
            if(this.smallPortal) {
                this.smallPortal.word.gainedFocus();
                this.smallPortal.word.updateCaret();
                this.smallPortal.enableBtn();
            }
            
            if(this.largePortal) this.largePortal.enableKeys();
        }
    }

    endGame()
    {
        this.largePortal.tweenOutPortal();
        this.smallPortal.tweenOutPortal();

        this.addTween(this.rivette.character.spine, 1000, {x:160, y:775}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{this.showDialogue(4);});
    }

    tweenOutGame(type)
    {
        this.navBar.tweenOutNav();
        this.addTween(this.gradient, 1000, {alpha:0}, Phaser.Math.Easing.Quadratic.Out);
        this.addTween(this.rivette.character.spine, 1500, {x:-230}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{this.cleanUp(type);});
    }

    cleanUp(type)
    {
        if(this.dialogue) this.dialogue.destroy();

        if(this.smallPortal) {
            this.smallPortal.cleanUp();
            this.smallPortal.destroy();
        }

        if(this.largePortal) {
            this.largePortal.cleanUp();
            this.largePortal.destroy();
        }

        if(this.rivette) {
            this.rivette.cleanUp();
            this.rivette.destroy();
        }

        if(this.navBar) {
            this.navBar.cleanUp();
            this.navBar.destroy();
        }

        this.scene.start(type);
    }
}